import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { label: '首页', href: '/' },
    { label: '分类', href: '/category/lianai', hasDropdown: true },
    { label: '排行榜', href: '/', hasDropdown: true },
    { label: '关于我们', href: '/about' },
  ];

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-400 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500">
              <i className={`ri-chat-smile-2-line text-lg md:text-xl ${scrolled || !isHome ? 'text-background-50' : 'text-background-50'}`}></i>
            </div>
            <span className={`font-heading font-bold text-lg md:text-xl ${scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'}`}>
              哈哈漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <div key={link.label} className="relative group">
                <Link
                  to={link.href}
                  className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                    scrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-500'
                      : 'text-background-50/90 hover:text-background-50'
                  }`}
                >
                  {link.label}
                  {link.hasDropdown && (
                    <i className="ri-arrow-down-s-line text-xs"></i>
                  )}
                </Link>
                {link.hasDropdown && link.label === '分类' && (
                  <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                    <div className="bg-background-50 rounded-lg py-2 px-1 shadow-sm border border-background-200/70 min-w-[120px]">
                      {[
                        { label: '恋爱', slug: 'lianai' },
                        { label: '奇幻', slug: 'qihuan' },
                        { label: '动作', slug: 'dongzuo' },
                        { label: '悬疑', slug: 'xuanyi' },
                        { label: '日常', slug: 'richang' },
                        { label: '搞笑', slug: 'gaoxiao' },
                      ].map((cat) => (
                        <Link
                          key={cat.slug}
                          to={`/category/${cat.slug}`}
                          className="block px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md whitespace-nowrap transition-colors cursor-pointer"
                        >
                          {cat.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <div className="hidden md:flex items-center gap-3">
              <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer">
                <i className={`ri-search-line text-base ${scrolled || !isHome ? 'text-foreground-700' : 'text-background-50'}`}></i>
              </button>
              <Link
                to="/category/lianai"
                className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始阅读
                <i className="ri-arrow-right-line text-sm"></i>
              </Link>
            </div>

            <button
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl ${scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.href}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-3 flex items-center gap-3">
              <button className="flex-1 px-4 py-2.5 rounded-full border border-background-300 text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap">
                搜索
              </button>
              <Link
                to="/category/lianai"
                className="flex-1 px-4 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium text-center hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                开始阅读
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}